/**
 * Gets paypal email from paypal payment name
 *
 * @param {object} opts
 * @param {object} opts.paypalPayment
 * @param {string} opts.defaultValue
 * @returns {string}
 */
const getPaypalEmail = (opts = {}) => {
  if (!opts || !opts.paypalPayment || !opts.paypalPayment.name) {
    return opts?.defaultValue || 'Unknown';
  }
  const namePieces = opts.paypalPayment.name.split('- ');
  return namePieces[1];
};

export default getPaypalEmail;
